// @ts-nocheck

import React, { useContext } from "react";
import cn from "classnames";
import Skeleton from "react-loading-skeleton";

import globalFormStyles from "../global.formElements.module.scss";
import { RadioProps } from "./Radio.props";
import styles from "./Radio.module.scss";

import { FormContext } from "../../Form";

/**
 * @deprecated Use `import { Radio } from capitalrx-components-2.0/lib/forms` instead.
 */
export const Radio: React.FC<RadioProps> = (props: RadioProps): JSX.Element => {
  const { id, onChange, label, name, disabled, large, containerClassName, value, validate, isLoading } = props;

  const { register, formState } = useContext(FormContext);
  const { errors, isFormLoading } = formState;

  // name is technically optional, but always injected by RadioGroup.
  if (!name || !register) {
    throw new Error("Component requires name");
  }

  let isInvalid = undefined;
  if (errors && Object.keys(errors)?.length) {
    isInvalid = name ? errors[name] : undefined;
  }

  const radioContainerClass = cn(
    globalFormStyles["form-field-container"],
    globalFormStyles["field-wrapper"],
    styles["radio-container"],
    containerClassName,
  );

  const radioWrapperClass = cn(
    styles["radio"],
    { [styles["radio-lg"]]: large },
    { [styles["radio-disabled"]]: disabled },
    { [styles["radio-invalid"]]: isInvalid !== undefined },
  );

  const radioIndicator = cn(styles["radio-checkmark"]);

  let component = null;

  if (isLoading || isFormLoading) {
    component = <Skeleton height={20} width={150} />;
  } else {
    const registerField = register(name, validate);
    component = (
      <label id={`radio-label-${id}`} className={radioWrapperClass}>
        <input
          {...registerField}
          aria-label={label}
          id={id}
          data-testid={`test__${id}`}
          type="radio"
          disabled={disabled}
          value={value}
          onChange={(e) => {
            onChange && onChange(e);
            registerField.onChange(e);
          }}
        />
        <div data-testid={`test__radio-${id}`} className={radioIndicator}></div>
        <span>{label}</span>
      </label>
    );
  }

  return <div className={radioContainerClass}>{component}</div>;
};

/**
 * @deprecated
 */
export default Radio;
